<template>
  <div>
    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="items !== null && items.length > 0" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">N</th>
          <th scope="col">Player</th>
          <th scope="col">Pending</th>
        </tr>
      </thead>
      <tr
        v-for="(item, index) in items"
        :key="item.playerId"
      >
        <td>
          {{index + 1}}
        </td>
        <td>
          <player-link :playerId="item.playerId" />
        </td>
        <td>
          <router-link
            :to="{name: 'player_pendings', params: {playerId: item.playerId}}"
          >
            pending {{item.pendingId}}
          </router-link>
        </td>
      </tr>
    </table>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';

import LoadingIndicator from './LoadingIndicator.vue';
import PlayerLink from './PlayerLink.vue';

export default {
  name: 'MassPendingPlayers',

  components: {
    LoadingIndicator,
    PlayerLink,
  },

  props: {
    massPendingId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      items: null,
    };
  },

  computed: {
    message() {
      if(this.items !== null && this.items.length === 0) {
        return 'No players.';
      }
      return null;
    },
  },

  created() {
    this.loadPlayers();
  },

  methods: {
    loadPlayers() {
      notifier.deleteSenderNotifications(this);
      this.isLoading = true;

      HTTP.get(`/mass_pending/${this.massPendingId}/players`)
      .then(response => {
        this.isLoading = false;

        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.items = data;
      })
      .catch(e => {
        this.isLoading = false;
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
}
</script>

<style scoped>
  /* minimize width of column with number */
  td:first-child {
    width: 1px;
  }
</style>
